import { isSystemAssembly } from './isSystemAssembly'
import { normalizeAssemblyName } from './normalizeAssemblyName'

/** Non-system assembly metadata indicates a graft package reference (self or cross-graft). */
export const isGraftAssemblyReference = (assemblyName: string | undefined): boolean => {
  const normalizedAssembly = normalizeAssemblyName(assemblyName)
  return Boolean(normalizedAssembly) && !isSystemAssembly(normalizedAssembly)
}
